// @flow

import {downloadByIFrame, downloadByStream} from './utils/download-methods';
import {CONTENT_TYPE_OCTET_STREAM} from './constants';
import type {DownloadFile} from './typedef';

const EMPTY_HEADER = '';

const isOctetStream = callInfo => (
    (callInfo.headers?.Accept ?? EMPTY_HEADER).includes(CONTENT_TYPE_OCTET_STREAM)
);

export const downloadFile: DownloadFile = (callInfo, API_ROOT) => (
    isOctetStream(callInfo) ?
        downloadByStream(callInfo, API_ROOT) :
        downloadByIFrame(callInfo, API_ROOT)
);

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
